import axios from 'axios';

const state = {
    products: [],
};
  
const getters = {
    allProducts: (state) => state.products,
};

const actions = {
    async fetchProducts({ commit }) {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await axios.get(`${process.env.VUE_APP_ROOT_API}/products?page=1&limit=25`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const data = await response.data;
            commit('setProducts', data);
        }
        catch (error) {
            console.error('Failed to fetch products:', error);
        }
    },
    createProduct({commit}, product) {
        return new Promise((resolve, reject) => {
            const token = localStorage.getItem('auth_token');
            axios.post(`${process.env.VUE_APP_ROOT_API}/products`, product, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(response => {
                const data = response.data;
                commit('addProduct', data);
                resolve(data);
            })
            .catch(error => {
                console.error('Failed to create product', error);
                reject(error);
            });
        });
    },
    async fetchProductById(_, id) {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await axios.get(`${process.env.VUE_APP_ROOT_API}/products/${id}`, {
                headers: {
                'Authorization': `Bearer ${token}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('Failed to fetch product:', error);
            throw error;
        }
    },
    async updateProduct({ commit }, product) {
        try {
          const token = localStorage.getItem('auth_token');
          const response = await axios.put(`${process.env.VUE_APP_ROOT_API}/products/${product.id}`, product, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          commit('updateProduct', response.data);
        }
        catch (error) {
          console.error('Failed to update product:', error);
          throw error;
        }
    },
    async deleteProductById({ commit }, id) {
        return new Promise((resolve, reject) => {
            const token = localStorage.getItem('auth_token');
            axios.delete(`${process.env.VUE_APP_ROOT_API}/products/${id}`, {
                headers: {
                'Authorization': `Bearer ${token}`
                }
            })
            .then(response => {
                commit('removeProduct', id);
                resolve(response.data);
            })
            .catch(error => {
                console.error('Failed to delete product', error);
                reject(error);
            });
        });
      }
};

const mutations = {
    setProducts(state, products) {
        state.products = products.data;
    },
    addProduct(state, product) {
        state.products.push(product);
    },
    updateProduct(state, updatedProduct) {
        const index = state.products.findIndex(product => product.id == updatedProduct.id);
        if (index !== -1) {
            state.products.splice(index, 1, updatedProduct);
        }
    },
    removeProduct(state, id) {
        state.products = state.products.filter(product => product.id !== id);
    }
};
  
export default {
    namespaced:true,
    state, mutations, actions, getters,
};    
  